import React from "react";

export const UseOnChange = () => {
    const [values, setValues] = React.useState({})
    const onChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value,
        });
    };

    return {
        onChange, values, setValues
    }
}